import {Component, OnDestroy, OnInit, ChangeDetectorRef, Input} from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {showSidebarSavedSearch} from 'user/actions/user-profile.actions';
import {Store} from '@ngrx/store';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-ap-saved-search-sidebar',
  templateUrl: './ap-saved-search-sidebar.component.html',
  styleUrls: ['./ap-saved-search-sidebar.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({transform: 'translateX(0%)', opacity: 1, zIndex: 30})),
      state('out', style({transform: 'translateX(100%)', opacity: 0, zIndex: 0})),
      transition('out => in', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out')
      ]),
      transition('in => out', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})

export class ApSavedSearchSidebarComponent implements OnInit, OnDestroy {
  @Input() public show: boolean;
  private readonly subscriptions = new Subscription();

  constructor(
    public store: Store,
    public cdRef: ChangeDetectorRef
  ) {
  }

  public ngOnInit() {
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onDismissActiveModal() {
    this.store.dispatch(showSidebarSavedSearch({sidebarSavedSearch: false}));
    this.cdRef.detectChanges();
  }
}
